// Mock data for Healthfluence prototype

export const mockCampaigns = [
  {
    id: '1',
    name: 'Spring Wellness Launch',
    status: 'in_progress',
    brand: 'MedTech Innovations',
    budget: 75000,
    spent: 45000,
    startDate: '2026-01-15',
    endDate: '2026-03-15',
    creatorsCount: 8,
    deliverablesCount: 24,
    completedDeliverables: 16,
    reach: 1250000,
    engagement: 4.8,
    primaryGoal: 'awareness',
  },
  {
    id: '2',
    name: 'Patient Education Series',
    status: 'content_review',
    brand: 'MedTech Innovations',
    budget: 50000,
    spent: 30000,
    startDate: '2026-02-01',
    endDate: '2026-04-01',
    creatorsCount: 5,
    deliverablesCount: 15,
    completedDeliverables: 8,
    reach: 890000,
    engagement: 5.2,
    primaryGoal: 'education',
  },
  {
    id: '3',
    name: 'New Product Announcement',
    status: 'matching',
    brand: 'MedTech Innovations',
    budget: 100000,
    spent: 0,
    startDate: '2026-03-01',
    endDate: '2026-05-01',
    creatorsCount: 0,
    deliverablesCount: 0,
    completedDeliverables: 0,
    reach: 0,
    engagement: 0,
    primaryGoal: 'conversion',
  },
  {
    id: '4',
    name: 'Healthcare Innovation Summit',
    status: 'draft',
    brand: 'MedTech Innovations',
    budget: 25000,
    spent: 0,
    startDate: '2026-04-15',
    endDate: '2026-04-30',
    creatorsCount: 0,
    deliverablesCount: 0,
    completedDeliverables: 0,
    reach: 0,
    engagement: 0,
    primaryGoal: 'engagement',
  },
]

export const mockCreators = [
  {
    id: '1',
    name: 'Dr. Betsy Grunch',
    title: 'Neurosurgeon & Health Educator',
    avatar: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=200&h=200&fit=crop',
    verified: true,
    tier: 'flagship',
    specialty: ['Neurosurgery', 'Brain Health', 'Spine'],
    platforms: {
      instagram: { followers: 850000, engagement: 4.8 },
      tiktok: { followers: 1200000, engagement: 6.2 },
      youtube: { followers: 450000, engagement: 3.9 },
    },
    totalReach: 2500000,
    avgEngagement: 5.0,
    campaignsCompleted: 45,
    onTimeRate: 98,
    rating: 4.9,
    bio: 'Board-certified neurosurgeon sharing brain health education. Making complex medical topics accessible for everyone.',
    location: 'Atlanta, GA',
    baseRate: 15000,
    availability: 'available',
  },
  {
    id: '2',
    name: 'Dr. Sarah Chen',
    title: 'Cardiologist & Wellness Advocate',
    avatar: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=200&h=200&fit=crop',
    verified: true,
    tier: 'macro',
    specialty: ['Cardiology', 'Heart Health', 'Preventive Care'],
    platforms: {
      instagram: { followers: 320000, engagement: 5.1 },
      linkedin: { followers: 150000, engagement: 4.2 },
    },
    totalReach: 470000,
    avgEngagement: 4.7,
    campaignsCompleted: 28,
    onTimeRate: 100,
    rating: 4.95,
    bio: 'Cardiologist passionate about heart health education and preventive medicine.',
    location: 'Boston, MA',
    baseRate: 8000,
    availability: 'available',
  },
  {
    id: '3',
    name: 'Marcus Johnson',
    title: 'Patient Advocate & Mental Health Speaker',
    avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop',
    verified: true,
    tier: 'mid_tier',
    specialty: ['Mental Health', 'Patient Advocacy', 'Chronic Illness'],
    platforms: {
      instagram: { followers: 125000, engagement: 6.8 },
      tiktok: { followers: 230000, engagement: 8.2 },
    },
    totalReach: 355000,
    avgEngagement: 7.5,
    campaignsCompleted: 15,
    onTimeRate: 95,
    rating: 4.8,
    bio: 'Sharing my journey with chronic illness to help others feel less alone. Mental health matters.',
    location: 'Chicago, IL',
    baseRate: 3500,
    availability: 'limited',
  },
  {
    id: '4',
    name: 'Dr. Emily Watson',
    title: 'Pediatrician & Child Health Educator',
    avatar: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=200&h=200&fit=crop',
    verified: true,
    tier: 'mid_tier',
    specialty: ['Pediatrics', 'Child Development', 'Parenting'],
    platforms: {
      instagram: { followers: 180000, engagement: 5.5 },
      youtube: { followers: 95000, engagement: 4.1 },
    },
    totalReach: 275000,
    avgEngagement: 4.8,
    campaignsCompleted: 22,
    onTimeRate: 97,
    rating: 4.85,
    bio: 'Pediatrician and mom of 3. Making child health info accessible for busy parents.',
    location: 'San Francisco, CA',
    baseRate: 4500,
    availability: 'available',
  },
  {
    id: '5',
    name: 'Amanda Torres, RN',
    title: 'ICU Nurse & Healthcare Educator',
    avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=200&h=200&fit=crop',
    verified: true,
    tier: 'micro',
    specialty: ['Nursing', 'Critical Care', 'Healthcare Workers'],
    platforms: {
      tiktok: { followers: 75000, engagement: 9.2 },
      instagram: { followers: 45000, engagement: 7.1 },
    },
    totalReach: 120000,
    avgEngagement: 8.2,
    campaignsCompleted: 8,
    onTimeRate: 100,
    rating: 5.0,
    bio: 'ICU nurse sharing the reality of healthcare. Advocating for nurses and patients alike.',
    location: 'Houston, TX',
    baseRate: 1500,
    availability: 'available',
  },
]

export const mockDeliverables = [
  {
    id: '1',
    campaignId: '1',
    creator: mockCreators[0],
    type: 'Instagram Reel',
    platform: 'instagram',
    status: 'approved',
    dueDate: '2026-02-01',
    submittedAt: '2026-01-28',
    approvedAt: '2026-01-30',
    metrics: { views: 450000, likes: 28000, comments: 1200, shares: 890 },
  },
  {
    id: '2',
    campaignId: '1',
    creator: mockCreators[0],
    type: 'TikTok Video',
    platform: 'tiktok',
    status: 'posted',
    dueDate: '2026-02-05',
    submittedAt: '2026-02-02',
    postedAt: '2026-02-04',
    postUrl: 'https://tiktok.com/@drbetsygrunch/video/123',
    metrics: { views: 1200000, likes: 85000, comments: 4500, shares: 12000 },
  },
  {
    id: '3',
    campaignId: '1',
    creator: mockCreators[1],
    type: 'Instagram Carousel',
    platform: 'instagram',
    status: 'brand_review',
    dueDate: '2026-02-10',
    submittedAt: '2026-02-08',
    currentDraftVersion: 2,
  },
  {
    id: '4',
    campaignId: '1',
    creator: mockCreators[2],
    type: 'Instagram Reel',
    platform: 'instagram',
    status: 'draft_submitted',
    dueDate: '2026-02-15',
    submittedAt: '2026-02-12',
    currentDraftVersion: 1,
  },
  {
    id: '5',
    campaignId: '1',
    creator: mockCreators[3],
    type: 'YouTube Short',
    platform: 'youtube',
    status: 'pending',
    dueDate: '2026-02-20',
  },
]

export const mockOpportunities = [
  {
    id: '1',
    campaignName: 'Spring Wellness Launch',
    brand: {
      name: 'MedTech Innovations',
      logo: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?w=100&h=100&fit=crop',
      verified: true,
    },
    budget: '$5,000 - $8,000',
    deadline: '2026-02-01',
    platforms: ['instagram', 'tiktok'],
    deliverables: ['2 Reels', '3 Stories'],
    status: 'pending_response',
    matchScore: 95,
    brief: 'Looking for healthcare creators to promote our new wellness tracking device...',
  },
  {
    id: '2',
    campaignName: 'Heart Health Awareness Month',
    brand: {
      name: 'CardioFirst',
      logo: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=100&h=100&fit=crop',
      verified: true,
    },
    budget: '$3,000 - $5,000',
    deadline: '2026-02-15',
    platforms: ['instagram', 'linkedin'],
    deliverables: ['1 Carousel', '2 Posts'],
    status: 'new',
    matchScore: 88,
    brief: 'February is Heart Health Month. Partner with us to spread awareness...',
  },
]

export const mockAnalytics = {
  overview: {
    totalReach: 2450000,
    totalEngagements: 125000,
    avgEngagementRate: 5.1,
    totalCampaigns: 4,
    activeCampaigns: 2,
    totalSpend: 75000,
    roi: 3.2,
  },
  reachByPlatform: [
    { platform: 'Instagram', reach: 1200000, percentage: 49 },
    { platform: 'TikTok', reach: 850000, percentage: 35 },
    { platform: 'YouTube', reach: 280000, percentage: 11 },
    { platform: 'LinkedIn', reach: 120000, percentage: 5 },
  ],
  performanceOverTime: [
    { date: 'Jan 1', reach: 50000, engagement: 2500 },
    { date: 'Jan 8', reach: 120000, engagement: 6000 },
    { date: 'Jan 15', reach: 280000, engagement: 14000 },
    { date: 'Jan 22', reach: 450000, engagement: 22500 },
    { date: 'Jan 29', reach: 680000, engagement: 34000 },
    { date: 'Feb 5', reach: 950000, engagement: 47500 },
    { date: 'Feb 12', reach: 1250000, engagement: 62500 },
  ],
  topPerformingContent: [
    { id: '1', creator: 'Dr. Betsy Grunch', type: 'TikTok Video', reach: 1200000, engagement: 8.5 },
    { id: '2', creator: 'Dr. Sarah Chen', type: 'Instagram Reel', reach: 450000, engagement: 5.2 },
    { id: '3', creator: 'Marcus Johnson', type: 'Instagram Story', reach: 320000, engagement: 7.8 },
  ],
}

export const statusColors = {
  draft: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Draft' },
  brief_submitted: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Brief Submitted' },
  matching: { bg: 'bg-purple-100', text: 'text-purple-700', label: 'Matching' },
  creators_selected: { bg: 'bg-indigo-100', text: 'text-indigo-700', label: 'Creators Selected' },
  funded: { bg: 'bg-cyan-100', text: 'text-cyan-700', label: 'Funded' },
  in_progress: { bg: 'bg-green-100', text: 'text-green-700', label: 'In Progress' },
  content_review: { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'Content Review' },
  completed: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Completed' },
  cancelled: { bg: 'bg-red-100', text: 'text-red-700', label: 'Cancelled' },
  pending: { bg: 'bg-gray-100', text: 'text-gray-700', label: 'Pending' },
  draft_submitted: { bg: 'bg-blue-100', text: 'text-blue-700', label: 'Draft Submitted' },
  hf_review: { bg: 'bg-purple-100', text: 'text-purple-700', label: 'Healthfluence Review' },
  brand_review: { bg: 'bg-orange-100', text: 'text-orange-700', label: 'Brand Review' },
  revisions_requested: { bg: 'bg-yellow-100', text: 'text-yellow-700', label: 'Revisions Requested' },
  approved: { bg: 'bg-green-100', text: 'text-green-700', label: 'Approved' },
  posted: { bg: 'bg-emerald-100', text: 'text-emerald-700', label: 'Posted' },
}

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)
}

export const formatNumber = (num) => {
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M'
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K'
  }
  return num.toString()
}
